import { Link } from "react-router-dom";
import useSeo from "@/hooks/useSeo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHero from "@/components/feature/PageHero";
import { popularWorks } from "@/mocks/doujinshi";

export default function Popular() {
  useSeo({
    title: "热门同人志榜单 | 人气作品与CP配对推荐",
    description:
      "同人志指南热门同人志榜单，收录近期口碑与热度俱佳的人气作品，附详细CP配对推荐、题材标签与评分，帮你快速找到值得一读的热门同人志。",
    path: "/popular",
  });

  const top = popularWorks.slice(0, 3);
  const rest = popularWorks.slice(3);

  return (
    <div className="bg-background-50">
      <Navbar />
      <PageHero
        eyebrow="Trending"
        title="热门同人志榜单"
        desc="人气与口碑双重加持的热门作品精选。每一部都附带细致的 CP 配对与题材标签，让入坑有据可依。"
        crumbs={[{ label: "热门榜单" }]}
      />

      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        {/* Top 3 highlight */}
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {top.map((w) => (
            <article key={w.id} className="group overflow-hidden rounded-2xl border border-background-200 bg-background-100">
              <div className="relative h-72 w-full overflow-hidden">
                <img src={w.image} alt={`${w.title}热门同人志封面`} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                <span className="absolute left-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-lg font-bold text-white shadow-md">
                  {w.rank}
                </span>
                <span className="absolute right-4 top-4 rounded-full bg-foreground-950/80 px-3 py-1 text-xs text-background-50">
                  ★ {w.rating}
                </span>
              </div>
              <div className="p-5">
                <h2 className="font-heading text-lg font-bold text-foreground-950">{w.title}</h2>
                <p className="mt-1 text-sm font-medium text-accent-700">{w.pairing}</p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{w.synopsis}</p>
                <div className="mt-4 flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800">{w.category}</span>
                  <span className="rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-700">{w.tag}</span>
                  <span className="text-xs text-secondary-500">{w.author} · 全{w.series}册</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Rest ranking list */}
        <h2 className="font-heading mt-14 text-xl font-bold text-foreground-950 md:text-2xl">更多人气作品</h2>
        <div className="mt-6 space-y-4">
          {rest.map((w) => (
            <article key={w.id} className="flex flex-col gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 sm:flex-row">
              <div className="relative h-44 w-full shrink-0 overflow-hidden rounded-xl sm:w-32">
                <img src={w.image} alt={`${w.title}同人志封面`} className="h-full w-full object-cover" loading="lazy" />
                <span className="absolute left-2 top-2 flex h-7 w-7 items-center justify-center rounded-full bg-foreground-950/80 text-xs font-bold text-background-50">
                  {w.rank}
                </span>
              </div>
              <div className="flex flex-1 flex-col">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950">{w.title}</h3>
                    <p className="mt-0.5 text-sm font-medium text-accent-700">{w.pairing}</p>
                  </div>
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800">★ {w.rating}</span>
                </div>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{w.synopsis}</p>
                <div className="mt-auto flex flex-wrap items-center gap-2 pt-3">
                  <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800">{w.category}</span>
                  <span className="rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-700">{w.tag}</span>
                  <span className="text-xs text-secondary-500">{w.author} · 全{w.series}册</span>
                  <Link to="/category" className="ml-auto inline-flex items-center gap-1 text-xs font-medium text-primary-700 hover:text-primary-800">
                    同类型更多 <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}